import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { ModalService } from '@services/modal.service';

@Component({
  selector: 'app-modal-payment-agreement-success',
  templateUrl: './modal-payment-agreement-success.component.html',
  styleUrls: ['./modal-payment-agreement-success.component.scss'],
})
export class ModalPaymentAgreementSuccessComponent implements OnDestroy {
  @Output() finish: EventEmitter<object> = new EventEmitter<object>();

  constructor(public modal: ModalService) {}

  ngOnDestroy() {
    this.modal.close();
  }

  accept() {
    this.modal.close();
    this.finish.emit();
  }
}
